import React from 'react';
import './css/index.scss';
import classnames from 'classnames';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3';
import { Link } from 'react-router-dom';

class RegisterPage extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
        showLoader: false,
        name: '',
        user: '',
        pass: '',
        pass2: '',
        recaptchaResponse: null,
        agree: false,
      };
  }

  componentDidMount() {
    loadReCaptcha(window.__env.recaptchaSiteKey);
  }

  verifyCallback = (recaptchaToken) => {
    // Here you will get the final recaptchaToken!!!  
    this.setState({recaptchaResponse:recaptchaToken});
  }

  render () {
    return (
      <div className="registerContainer">
        <div className="secondaryHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-400px'}}>
            <h1>Cont Nou</h1>
            <div className="row">
                <div className="half">
                    <div className="login-box-page">
                        
                        <form method="post" action="" onSubmit={(event)=>{
                            event.preventDefault(); // Let's stop this event.
                            event.stopPropagation(); // Really this time.
                        }}>
                        <div>
                            {this.props.registerErrors !== null && this.props.registerErrors.name !== undefined ? <div className="error-text">{this.props.registerErrors.name.join(' ')}</div> : null}
                            <input type="text" className={classnames({'error': this.props.registerErrors !== null && this.props.registerErrors.name !== undefined})} name="taburiNameLP" onChange={(e)=>{this.setState({name: e.target.value})}} value={this.state.name} placeholder="nume" />
                        </div>
                        <div>
                            {this.props.registerErrors !== null && this.props.registerErrors.email !== undefined ? <div className="error-text">{this.props.registerErrors.email.join(' ')}</div> : null}
                            <input type="text" className={classnames({'error': this.props.registerErrors !== null && this.props.registerErrors.email !== undefined})} name="taburiEmailLP" onChange={(e)=>{this.setState({user: e.target.value})}} value={this.state.user} placeholder="email" />
                        </div>
                        <div>
                            {this.props.registerErrors !== null && this.props.registerErrors.password !== undefined ? <div className="error-text">{this.props.registerErrors.password.join(' ')}</div> : null}
                            <input autoComplete="off" type="password" className={classnames({'error': this.props.registerErrors !== null && this.props.registerErrors.password !== undefined})} name="taburiPassLP" onChange={(e)=>{this.setState({pass: e.target.value})}} value={this.state.pass} placeholder="parolă" />
                        </div>
                        <div>
                            {this.props.registerErrors !== null && this.props.registerErrors.password_confirmation !== undefined ? <div className="error-text">{this.props.registerErrors.password_confirmation.join(' ')}</div> : null}
                            <input autoComplete="off" type="password" className={classnames({'error': this.props.registerErrors !== null && this.props.registerErrors.password_confirmation !== undefined})} name="taburiPassLP" onChange={(e)=>{this.setState({pass2: e.target.value})}} value={this.state.pass2} placeholder="verifică parolă" />
                        </div>
                        <div style={{paddingBottom: '10px'}}>
                            {this.props.registerErrors !== null && this.props.registerErrors.agree !== undefined ? <div className="error-text">{this.props.registerErrors.agree.join(' ')}</div> : null}
                            <input id="tnc" type="checkbox" className={classnames({'error': this.props.registerErrors !== null && this.props.registerErrors.agree !== undefined})} name="agreement" onChange={(e)=>{this.setState({agree: !this.state.agree})}} value={this.state.agree === true ? 'accepted' : 'off'} placeholder="verifică parolă" />
                            <label for="tnc">Sunt de acord cu <Link style={{color: '#007bd9'}} to="/termeni-si-conditii">Termenii și Condițiile</Link></label>
                        </div>
                        <div style={{textAlign: 'center'}}>
                            {this.props.registerErrors !== null && this.props.registerErrors.recaptchaResponse !== undefined ? <div className="error-text">{this.props.registerErrors.recaptchaResponse.join(' ')}</div> : null}
                        </div>
                        <div style={{textAlign: 'center', display: 'flex', paddingBottom: '20px'}}>
                            <ReCaptcha
                                sitekey={window.__env.recaptchaSiteKey}
                                action='action_name'
                                verifyCallback={this.verifyCallback}
                            />
                        </div>
                        <div>
                           {this.props.registerErrors !== null && this.props.registerErrors.error !== undefined ? <div className="error-text-2">{this.props.registerErrors.error}</div> : null}
                            <button onClick={()=>{this.props.register({name: this.state.name, user: this.state.user, pass: this.state.pass, pass2: this.state.pass2, recaptchaResponse: this.state.recaptchaResponse, agree: this.state.agree})}}>Creează Cont Nou</button>
                        </div>
                        <div>
                        <p style={{textAlign: 'center'}}>SAU dacă ai deja un cont</p>
                        </div>
                        <div>
                            <button onClick={()=>{window.location = '/autentificare';}}>Intră în cont</button>
                        </div>
                        </form>
                    </div>
                </div>
                <div className="half gate">
                </div>
            </div>
           
          </div>
        </div>
      </div>
    );
  }
}

export default RegisterPage;



// WEBPACK FOOTER //
// ./src/components/registerPage/registerPage.js